import type { Data } from '@/api/api.ts'
import type {
  AuthPhoneNumberRequestData,
  AuthPhoneNumberRequestParams,
  ClientPhoneNumberRequestData,
  ClientPhoneNumberRequestParams,
  LoginRequestData,
  LoginRequestParams,
  RegistrationRequestData,
  RegistrationRequestParams,
  RegistrationRequestParamsData,
} from '@/types/authentication.types.ts'
import axios from 'axios'
import { baseUrl } from '@/constants/api.ts'

const urlPrefix = `${baseUrl}user/auth/incoming-call/`

export const getAuthPhoneNumber = async (
  params: AuthPhoneNumberRequestParams,
): Promise<Data<AuthPhoneNumberRequestData>> => axios.get(`${urlPrefix}phonedst/`, { params })

export const getClientPhoneNumber = async (
  params: ClientPhoneNumberRequestParams,
): Promise<Data<ClientPhoneNumberRequestData>> => axios.get(`${urlPrefix}phonesrc/`, { params })

export const loginClient = async (params: LoginRequestParams): Promise<Data<LoginRequestData>> =>
  axios.post(
    `${urlPrefix}login/`,
    {},
    {
      params,
    },
  )

export const registrationClient = async (
  data: RegistrationRequestParamsData,
  params: RegistrationRequestParams,
): Promise<Data<RegistrationRequestData>> =>
  axios.post(`${urlPrefix}registration/`, data, {
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  })

export const setOldAuth = async (): Promise<Data<any>> =>
  axios.post(
    `${baseUrl}user/auth/set-old-auth/`,
    {},
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
  )
